import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerDetalleObjetorEvento = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Bitacora/DetalleObjetarEvento",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ObtenerDetalleObjetorEvento };